<template>
  <div v-loading.fullscreen.lock="loading" class="apply">
    <!-- 头部开始 -->
    <top-part></top-part>
    <!-- 头部结束 -->
    <!-- 签名弹出层 -->
    <div v-show="test" class="sign" style="position:fixed;top:0;z-index:9999;bottom:0">
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <!-- 签名弹出层结束 -->
    <div class="apply-content-box">
      <!-- form校验 -->
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="90px !important"
        style="height: 100%;overflow: scroll;"
      >
      <el-form-item label="提示" prop="" class="form-item" v-if="configuration.limitFlag == 1">
          <div style="color: red">
            你可用申请次数{{ configuration.limitCount }}
          </div>
        </el-form-item>
        <!-- 姓名选择框 -->
        <el-form-item label="姓名" prop="name" class="form-item">
          <div @click="openPersonnel" style="width:230px;">
            <span>{{form.name}}</span>
            <van-icon name="arrow" class="right-icon" />
          </div>
        </el-form-item>
        <!-- 姓名选择框结束 -->
        <!-- 科室选择框 -->
        <el-form-item label="科室" class="form-item left-lable-box">
          <p>{{form.deptName}}</p>
        </el-form-item>
        <!-- 科室选择框结束 -->
        <!-- 慰问类型 -->
        <el-form-item label="住院类型" prop="type" class="form-item">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 慰问类型结束 -->
        <!--住院津贴申报   只有选择是疾病才会展示  prop="declare" -->
        <el-form-item label="住院津贴申报" prop="declare" class="form-item" v-if="form.type==2">
          <el-switch
            active-color="#38c7c4"
            v-model="form.declare"
            active-value="1"
            inactive-value="2"
            style="position: absolute;right: 0;top: 0;bottom: 0;margin: auto;"
          ></el-switch>
        </el-form-item>
        <!--住院津贴申报结束  -->
        <!-- 住院日期 -->
        <el-form-item prop="desc" label="住院日期" class="form-item">
          <div @click="show = true" class="aaa">
            <span>{{date}}</span>
            <van-icon name="arrow" class="right-icon" />
          </div>
          <!-- 时间组件开始 -->
          <van-calendar
            color="#29BEBC"
            v-model="show"
            @confirm="onConfirm"
            :min-date="minDate"
            :max-date="maxDate"
          />
          <!-- 时间组件结束 -->
        </el-form-item>
        <!-- 住院日期结束 -->
        <!-- 事由 -->
        <el-form-item label="住院事由" prop="desc" class="form-item">
          <el-input type="textarea" v-model="form.desc" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <!-- 事由结束 -->
          <el-form-item label="上传附件" class="form-item left-lable-box" prop="data">
          <van-uploader
            :max-size="maxSize * 1024 * 1024"
            @oversize="onOversize"
            @delete="onDeleteFile"
            accept=""
            :disabled="fileMessage == '上传中'"
            v-model="form.data"
            max-count="5"
            :after-read="afterImgRead"
          />
        </el-form-item>
        <!-- 签名 -->
        <el-form-item label="签名" prop="imgData" class="form-item">
          <div v-if="form.imgData" class="resign">
            <div style="width:50px">
              <img class="sign-img" :src="form.imgData" />
            </div>
            <span @click="showPopup" class="resign-txt">重新签名</span>
          </div>
          <el-button v-else class="sign-btn" @click="showPopup">
            <span class="img"></span>签名
          </el-button>
        </el-form-item>
        <!-- 签名结束 -->
      </el-form>
      <!-- form校验结束 -->
    </div>
    <!-- 按钮框 -->
    <div class="sure-box" @click="onSubmit" v-if="bottomShow &&
            !(configuration.limitFlag == 1 && configuration.limitCount == 0)">
      <span>{{isOk}}</span>
    </div>
    <!-- 按钮框结束 -->
  </div>
</template>
<script>
import { toast } from "@/common/api/api.js";
import { signinHonoreeSignature, getWXInfo,getApprovalCountByUserId } from "@/common/api";
import signature from "../../../components/signature.vue";
import topPart from "../../../components/topPart";
import moment from "moment";
import timeDate from "../../../components/time";
export default {
  name: "condoleApply",
  components: {
    signature,
    topPart,
    timeDate
  },
  data() {
    return {
      fileList: [],
      fileMessage: "",
      fileCount: 0,
      maxSize: 200,
      configuration: {},
      isOk: "确定", //按钮文字
      isOkFlag: false, //按钮标识
      date: "请选择住院日期", //存取时间 //住院日期
      show: false, //控制时间控件是否显示
      minDate: new Date(2019, 0, 1),
      maxDate: this.date,
      rules: this.centralControl.check.getCheckConfig("hospitalization"),
      comfortType: "", //类型标识
      loading: false,
      form: {
        declare: "2", //津贴申报
        name: "请选择慰问人员的姓名", //被申请人姓名
        deptName: "", //科室名称
        unionName: "", //分会名称
        type: "", //慰问住院类型
        desc: "", //住院事由
        nameId: "", // 申请人ID
        data: [], //图片盒子
        imgData: "" //签名
      },
      options: [],
      test: false, //打开签名标识
      loginInfo: "", //登录这信息
      validateData: [
        //表单校验
        { item: "nameId", code: "申请人不能为空" },
        { item: "desc", code: "住院事由不能为空" },
        { item: "imgData", code: "请签名,不能为空" }
      ],
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      bottomShow: true
    };
  },
  created() {
    //获取标识位
    this.comfortType = this.centralControl.utils.getConfig(
      this.centralControl.config,
      ["sympathy", "hospitalization", "type"]
    );

    //获取申请补助事由
    this.getReasonsForSubsidy();
    this.loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    let selPerson = this.$route.query.person;
    if (selPerson) {
      this.form.name = selPerson.name || "请选择慰问人员的姓名";
      this.form.deptName = selPerson.deptName;
      this.form.unionName = selPerson.unionName;
      this.form.nameId = selPerson.id;
       this.getApprovalCountByUserId(selPerson.id);
    }else {
      this.getApprovalCountByUserId(this.loginInfo.id);
    }
  },
  watch: {
    showHeight: function() {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.bottomShow = false;
      } else {
        //显示
        this.bottomShow = true;
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
  },

  methods: {
    // 验证文件类型
    isValidFileType(file) {
      const fileName = file.name.toLowerCase();
      const fileType = file.type.toLowerCase();
      // 允许的文件扩展名
      const allowedExtensions = [
        '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', // 图片格式
        '.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx', '.ppt', '.pptx' // 文档格式
      ];
      // 允许的MIME类型
      const allowedMimeTypes = [
        // 图片类型
        'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp',
        // 文档类型
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      ];
      // 检查文件扩展名
      const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
      // 检查MIME类型
      const hasValidMimeType = allowedMimeTypes.includes(fileType);
      // 只要其中一个验证通过就允许上传
      return hasValidExtension || hasValidMimeType;
    },
    // 上传完图片的时的钩子函数
    afterImgRead(file) {
      console.log(file);
      // 验证文件类型
      if (!this.isValidFileType(file.file)) {
        file.status = "failed";
        file.message = "文件格式不支持";
        toast(this, "只支持图片和文档格式（jpg、png、gif、pdf、doc、docx、txt、xls、xlsx、ppt、pptx）", "error");
        return;
      }
      file.status = "uploading";
      file.message = "上传中...";
      this.fileMessage = "上传中";
      var obj = { file: this.form.data[this.fileCount].file };

      this.centralControl.axios.centralControl(
        "uploadFile",
        (res) => {
          const { data, code, message } = res;
          if (code == "200") {
            file.status = "success";
            file.message = "上传成功";
            // 将 fileKey 保存到文件对象中，方便删除时使用
            file.fileKey = data.fileKey;
            this.fileList.push(data.fileKey);
            this.fileCount = this.fileCount + 1;
            this.fileMessage = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        },
        obj
      );
      console.log(file);
    },
    onOversize() {
      toast(this, `文件大小不能超过${this.maxSize}M`, "error");
    },
    // 删除文件的回调函数
    onDeleteFile(file, detail) {
      try {
        if (file.status === "success" && file.fileKey) {
          const index = this.fileList.findIndex(fileKey => fileKey === file.fileKey);
          if (index !== -1) {
            this.fileList.splice(index, 1);
            console.log("从 fileList 中删除文件:", file.fileKey);
          }
        }
        // 更新文件计数器，确保不会小于0
        if (this.fileCount > 0) {
          this.fileCount = this.fileCount - 1;
        }
        // 重置文件上传状态
        if (this.form.data.length === 0) {
          this.fileMessage = "";
          this.fileCount = 0; // 重置计数器
        }
        toast(this, "文件删除成功", "success");
      } catch (error) {
        console.error("删除文件时出错:", error);
        toast(this, "删除文件失败", "error");
      }
    },
        getApprovalCountByUserId(id) {
      var obj = {
        comfortType: this.comfortType,
        staffId: id,
      };
      getApprovalCountByUserId(obj).then((res) => {
        if (res.code == 200) {
          this.configuration = res.data;
        }
      });
    },
    //获取参数
    getReasonsForSubsidyData() {
      var obj = {
        dictType: "hospitalization"
      };
      return obj;
    },
    //获取住院类型审核
    getReasonsForSubsidy() {
      var obj = this.getReasonsForSubsidyData();
      this.centralControl.axios.centralControl(
        "getUserDictValue",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.options = data;
            this.form.type = this.options[0].dictValue;
          }
        },
        obj
      );
    },
    //时间控件控制函数
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
    validate() {
      let obj = { flag: true };
      for (let a = 0; a < this.validateData.length; a++) {
        if (!this.form[this.validateData[a].item]) {
          obj.flag = false;
          obj.token = a;
          return obj;
        }
      }
      return obj;
    },

    onSubmit() {
      if (this.isOkFlag) {
        toast(this, "提交中请稍等", "error");
        return;
      }

      var configObj = this.validate();
      if (!configObj.flag) {
        toast(this, this.validateData[configObj.token].code, "error");
        return;
      }
      if(!this.fileList.length) {
        toast(this, '请上传附件', "error");
        return;
      }
      if (this.date == "请选择住院日期") {
        toast(this, "住院日期不能为空");
        return;
      }
      this.isOkFlag = !this.isOkFlag;
      this.isOk = "提交中...";
      this.loading = true;
      var obj = {
        dataApplication: this.date, //申请日期
        comfortType: this.comfortType, //申请类型
        handle: this.loginInfo.id, //申请人ID
        nameId: this.form.nameId, //被申请人
        secondaryType: this.form.type + "", //慰问类型
        reason: this.form.desc, //住院事由
        applierSign: this.form.imgData, //签名
        name: this.loginInfo.name, //申请人名称
        company: this.loginInfo.unionName, //申请人分会
        unionId:this.loginInfo.unionId,
        fileList: JSON.stringify(this.fileList),

      };
      if (this.form.type == 2) {
        obj.allowance = this.form.declare; //二级标识
      }
      this.centralControl.axios.centralControl(
        "addSympathy",
        res => {
          this.loading = false;
          if (res.code == 200) {
            this.fileCount = 0; //计时器归零
            this.fileList = [];
            toast(this, "提交成功");
            this.$router.push({
              path: "/hospitalization"
            });
          } else {
            this.isOk = "确定"; //按钮文字
            this.isOkFlag = false; //按钮标识
            toast(this, res.message, "error");
          }
        },
        obj
      );
    },
    cancel() {
      this.form.nameId = "";
      this.form.name = "";
      this.form.deptName = "";
      this.form.unionName = "";
      this.form.type = "1";
      this.form.desc = "";
      this.form.imgData = "";
      this.form.data = [];
      this.fileList = [];
    },
    //人员管理
    openPersonnel() {
      this.$router.push({
        path: "/sympathyManagement",
        query: {
          router: "/hospitalizationApply",
          status: 1 // 1 选择人员
        }
      });
    },
    complete(data) {
      if (data) {
        this.form.imgData = data;
        this.test = false;
      }
      this.bottomShow = true;
    },
    showPopup() {
      this.test = !this.test;
      this.bottomShow = false;
    },
    closePop() {
      this.test = false;
      this.bottomShow = true;
    },
    handleBlur() {
      document.activeElement.blur();
    }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';

// .el-switch{
// height: 40px !important;
// .el-switch__core {
// height: 100%;
// }
// }
.apply >>> .el-select .el-input.is-focus .el-input__inner {
  border-color: $default-color;
}

.el-select-dropdown__item.selected {
  color: $default-color;
}

.form-item {
  >>>.el-textarea {
    border-color: $default-color;
  }

  >>>.el-select .el-input__inner:focus {
    border-color: $default-color;
  }
}

.apply-content-box {
  myContent();
  bottom: 74px;
}

.right-icon {
  font-size: 16px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 36px;
}

.sure-box {
  height: 44px;
  background: rgba(41, 190, 188, 1);
  border-radius: 5px;
  line-height: 44px;
  color: #fff;
  width: 90%;
  text-align: center;
  margin: 0 auto 0;
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
}

.sign {
  #wrapper {
    .rewrite {
      right: 0 !important;
      left: 50% !important;
      top: -60%;
      transform: rotate(270deg) translateY(-50%) !important;
    }
  }
}

.el-form {
  .el-textarea .el-input__count {
    line-height: 13px;
    font-size: 12px;
  }

  .overflowText {
    .el-form-item__label {
      line-height: 24px;
      text-align: center !important;
    }
  }

  .sign {
    .el-form-item__label {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .resign {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .sign-img {
        width: 200px;
        height: 150px;
        transform: rotate(90deg);
      }
    }
  }

  .resign {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sign-img {
      width: 60px;
      height: 60px;
      transform: rotate(90deg);
    }

    .resign-txt {
      font-style: normal !important;
    }
  }

  .form-item {
    background: #fff;
    padding: 10px 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #f4f4f4;
    position: initial;

    .el-form-item__label {
      text-align: left;
      // width: 80px !important;
      color: $text-black;
    }

    .el-form-item__content {
      margin-left: 70px !important;
      position: relative !important;
      color: $text-gray;
      // text-align :right;
    }

    .input {
      .el-input__inner {
        border: none;
        padding: 0;
      }
    }

    .input-sel {
      width: calc(100% - 40px);
    }

    .sel-txt, .resign-txt {
      color: $default-color;
      font-size: 12px;
      font-style: italic;
      display: inline-block;
      text-align: center;
    }

    .sign-btn {
      width: 100%;
      color: #38c7c4;
      border-color: $default-color;
      background-color: #fff;

      .img {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('/img/icon-sign.00caefc8.png') no-repeat center center;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 5px;
      }
    }

    .el-radio-group {
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 40px;
      line-height: 40px;
    }

    .el-radio {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
  }

  .submit-btn {
    position: relative;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
    padding: 10px 0;
    text-align: center;
    border-top: 1px solid $border-color;
    font-size: 18px;
    background: #fff;

    .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }

    .el-button--primary {
      color: #FFF;
      background-color: $default-color;
      border-color: $default-color;
      width: 150px;
      height: 44px;
      background: $default-color;
      border-radius: 5px;
      font-size: 18px;
    }

    .btn-cancel {
      background-color: #fff;
      color: $default-color;
    }
  }

  .el-radio__original, .el-radio__input, .el-radio__inner {
    width: 23px;
    height: 23px;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: $default-color;
    background: $default-color;
    width: 23px;
    height: 23px;
  }

  .el-radio__inner::after {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../assets/images/sel-checked.png') no-repeat center center;
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 5px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: $default-color;
  }

  .el-textarea__inner:focus {
    border-color: $default-color;
  }
}
</style>